import { IconTypes } from './Icons'

export default function Global({
  color = '#00DCBD',
  fontSize = '1.6rem',
  rotate = 0,
  className = '',
}: IconTypes) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill={color}
      style={{
        width: '1em',
        height: '1em',
        fontSize,
        transform: `rotate(${rotate}deg)`,
      }}
      className={className}
    >
      <path
        d='M8.00004 15.1667C4.04671 15.1667 0.833374 11.9533 0.833374 8.00001C0.833374 4.04668 4.04671 0.833344 8.00004 0.833344C11.9534 0.833344 15.1667 4.04668 15.1667 8.00001C15.1667 11.9533 11.9534 15.1667 8.00004 15.1667ZM8.00004 1.83334C4.60004 1.83334 1.83337 4.60001 1.83337 8.00001C1.83337 11.4 4.60004 14.1667 8.00004 14.1667C11.4 14.1667 14.1667 11.4 14.1667 8.00001C14.1667 4.60001 11.4 1.83334 8.00004 1.83334Z'
        fill={color}
      />
      <path
        d='M6.00003 14.5H5.33337C5.06003 14.5 4.83337 14.2733 4.83337 14C4.83337 13.7267 5.0467 13.5067 5.32003 13.5C4.27337 9.92667 4.27337 6.07333 5.32003 2.5C5.0467 2.49333 4.83337 2.27333 4.83337 2C4.83337 1.72667 5.06003 1.5 5.33337 1.5H6.00003C6.16003 1.5 6.31337 1.58 6.4067 1.70667C6.50003 1.84 6.5267 2.00667 6.47337 2.16C5.22003 5.92667 5.22003 10.0733 6.47337 13.8467C6.5267 14 6.50003 14.1667 6.4067 14.3C6.31337 14.42 6.16003 14.5 6.00003 14.5Z'
        fill={color}
      />
      <path
        d='M9.99998 14.5C9.94665 14.5 9.89331 14.4933 9.83998 14.4733C9.57998 14.3867 9.43331 14.1 9.52665 13.84C10.78 10.0733 10.78 5.92667 9.52665 2.15334C9.43998 1.89334 9.57998 1.60667 9.83998 1.52001C10.1066 1.43334 10.3866 1.57334 10.4733 1.83334C11.8 5.80667 11.8 10.18 10.4733 14.1467C10.4066 14.3667 10.2066 14.5 9.99998 14.5Z'
        fill={color}
      />
      <path
        d='M8 11.4667C6.14 11.4667 4.28667 11.2067 2.5 10.68C2.49333 10.9467 2.27333 11.1667 2 11.1667C1.72667 11.1667 1.5 10.94 1.5 10.6667V10C1.5 9.84 1.58 9.68666 1.70667 9.59333C1.84 9.5 2.00667 9.47333 2.16 9.52666C5.92667 10.78 10.08 10.78 13.8467 9.52666C14 9.47333 14.1667 9.5 14.3 9.59333C14.4333 9.68666 14.5067 9.84 14.5067 10V10.6667C14.5067 10.94 14.28 11.1667 14.0067 11.1667C13.7333 11.1667 13.5133 10.9533 13.5067 10.68C11.7133 11.2067 9.86 11.4667 8 11.4667Z'
        fill={color}
      />
      <path
        d='M14 6.50001C13.9467 6.50001 13.8934 6.49334 13.84 6.47334C10.0734 5.22001 5.92002 5.22001 2.15335 6.47334C1.88669 6.56001 1.60669 6.42001 1.52002 6.16001C1.44002 5.89334 1.58002 5.61334 1.84002 5.52668C5.81335 4.20001 10.1867 4.20001 14.1534 5.52668C14.4134 5.61334 14.56 5.90001 14.4667 6.16001C14.4067 6.36668 14.2067 6.50001 14 6.50001Z'
        fill={color}
      />
    </svg>
  )
}
